import { useCallback, useEffect, useState } from "react";
import TaskDetailView from "@/components/TaskDetailView";
import { BottomSheet, PrevNextPager, useIsMobile } from "@/components/shared/PagePrimitives";
import { ReviewPanel } from "@/components/shared/ReviewPanel";

// Glass modal for a task detail, usable anywhere a task is clicked.
// taskIds = ordered ids of the currently displayed (filtered) list for ←/→ navigation.
// Na mobilu se místo dialogu vykreslí spodní šuplík (zadání 90) — stejný obsah.
// 356: na počítači panel zprava jako detail faktury a kontrola docházky — „2 / 5“ a ↑ ↓ (i ← →) další úkol,
// mezerník nebo Esc zavře.
export default function TaskDetailModal({ taskId, taskIds = [], open, onOpenChange, onNavigate, onChanged, initialAction }) {
  const isMobile = useIsMobile();
  const [slot, setSlot] = useState(null);   // 357: místo vlevo v hlavičce panelu pro Schválit / Označit jako hotové
  const idx = taskIds.indexOf(taskId);
  const hasPrev = idx > 0;
  const hasNext = idx >= 0 && idx < taskIds.length - 1;

  const go = useCallback((dir) => {
    if (!onNavigate || idx < 0) return;
    const ni = idx + dir;
    if (ni >= 0 && ni < taskIds.length) onNavigate(taskIds[ni]);
  }, [idx, taskIds, onNavigate]);

  useEffect(() => {
    if (!open || isMobile) return;
    const h = (e) => {
      if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
      if (e.key === "ArrowLeft") go(-1);
      if (e.key === "ArrowRight") go(1);
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, go, isMobile]);

  // 175: vlevo listování (obě šipky u sebe + pořadí), vpravo jen křížek — jeden řádek,
  // nic se nepřekrývá. Na mobilu to kreslí hlavička BottomSheet, na PC přilepená lišta okna.
  const pager = taskIds.length > 1 && idx >= 0 && (
    <PrevNextPager index={idx} total={taskIds.length} onPrev={() => go(-1)} onNext={() => go(1)} testid="task-modal" />
  );
  const body = taskId && <TaskDetailView id={taskId} onChanged={onChanged} onClose={() => onOpenChange(false)} initialAction={initialAction} headerSlot={isMobile ? null : slot} keys={isMobile ? null : "panel"} />;

  if (isMobile) {
    return (
      <BottomSheet open={open} onOpenChange={onOpenChange} actions={pager} title="Detail úkolu" testid="task-detail-modal">
        {body}
      </BottomSheet>
    );
  }

  const nav = onNavigate && idx >= 0 ? { index: idx, count: taskIds.length, onGo: (i) => onNavigate(taskIds[i]) } : null;
  return (
    <ReviewPanel open={open} onClose={() => onOpenChange(false)} nav={nav} testid="task-detail-modal" title="Detail úkolu" noun="úkol" bg="bg-card">
      {(controls) => (<>
        <div className="flex items-center justify-between gap-3 px-6 py-3 border-b border-border/60" data-testid="task-modal-header">
          <div ref={setSlot} className="flex items-center gap-2 min-w-0" data-testid="task-modal-actions" />
          {controls}
        </div>
        <div className="overflow-y-auto overscroll-contain px-6 py-5">{body}</div>
      </>)}
    </ReviewPanel>
  );
}
